const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const SalesExecutive = 'SalesExecutive'
const Financial = "Financial"
const Logistics = 'Logistics'
const Seller = 'Seller'
const CreditAnalyst = 'CreditAnalyst'

export default [
  {
    path: '/buildings/create',
    name: 'CreateBuilding',
    component: () => import('@/_backoffice/_registrations/components/buildings/CreateBuilding.vue'),
    meta: {
      auth: true,
      roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
    },
    
  },
  {
    path: '/buildings',
    name: 'Buildings',
    component: () => import('@/_backoffice/_registrations/components/buildings/Buildings.vue'),
    meta: {
      auth: true,
      roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
    },
    
    children:[
      {
        path: ':id',
        name: 'ShowBuilding',
        component: () => import('@/_backoffice/_registrations/components/buildings/ShowBuilding.vue'),
        meta: {
          auth: true,
          roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst]
        },
        
      },
    ]
  },



]